import styled from "styled-components";
import Colors from "../../constants/Colors";

export const ModalContainer = styled.div<{ isMobile?: boolean }>`
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 95vw;
  width: ${(props) => (props.isMobile ? "90%" : "600px")};
  background-color: #ffffff;
  padding: 32px;
  outline: none;
`;

export const ModalTitle = styled.h2`
  font-family: "Sora", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: ${Colors.SPM800};
  text-align: center;
  margin-bottom: 8px;
`;

export const ModalSubtitle = styled.p`
  font-family: "Sora", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: ${Colors.SPM600};
  text-align: center;
  margin-bottom: 24px;
`;

export const Label = styled.label`
  font-family: "Sora", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${Colors.SPM800};
  align-self: flex-start;
  margin-bottom: 8px;
  display: block;
  text-align: left;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 120px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Sora", sans-serif;
  font-size: 14px;
  resize: none;
  margin-bottom: 24px;

  &:focus {
    outline: none;
    border-color: ${Colors.SPM600};
  }
`;

export const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  width: 100%;
`;

export const ErrorText = styled.span`
  color: red;
  font-size: 12px;
  margin-top: -16px;
  margin-bottom: 16px;
  align-self: flex-start;
  display: block;
  text-align: left;
`;
